import Swiper from 'swiper/bundle'

const sliderInit = () => {
  const body = document.querySelector('body')

  /**
   * main visual slider init
   */
  if (document.querySelector('.main-visual-slider')) {
    const mainVisualSlider = new Swiper('.main-visual-slider', {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: (number) => {
          if (number < 10) {
            return '0' + number
          } else {
            return number
          }
        },
        formatFractionTotal: (number) => {
          if (number < 10) {
            return '0' + number
          } else {
            return number
          }
        },
      },
      on: {
        slideChange: () => {
          body.classList.remove('is-main-visual-bar-active')
          setTimeout(() => {
            body.classList.add('is-main-visual-bar-active')
          }, 10)
        },
      },
    })
  }

  /**
   * product thumbnail slider init
   */
  const productSlider = document.querySelector('.product-slider')
  if (productSlider) {
    const slideLength = document.querySelectorAll('.product-slider .swiper-slide').length
    if (slideLength > 1) {
      const mainVisualSlider = new Swiper('.product-slider', {
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
      productSlider.classList.add('has-slider')
    }
  }
}

export { sliderInit }
